import { DomSelector } from "./dom-selector";
import { Logger } from "../../logger/logger";

interface IWidgetResult {
	element: Element;
	widgetType: string;
	widgetInstance: DevExpress.ui.Widget<any>;
	widgetOptions: DevExpress.ui.WidgetOptions<any>;
}

export class DxWidgetSelector {
	public static async printSelectedWidgets() {
		let domSelector = new DomSelector((elem) => {
			let result = this.getDxWidgetByElement(elem);
			return result.length !== 0 && result[result.length - 1].element;
		});

		let element = await domSelector.runAsync();
		if (element) {
			let result = this.getDxWidgetByElement(element);
			Logger.table(result);
		}
	}

	public static getDxWidgetByElement(element: Element): IWidgetResult[] {
		let result: IWidgetResult[] = [];

		while (element) {
			let $elem = $(element) as any;
			for (let key of Object.keys($elem.__proto__)) {
				if (key.startsWith("dx") && typeof $elem[key] === "function") {
					let widget: DevExpress.ui.Widget<any> = null;
					try {
						widget = $elem[key]("instance");
					} catch {
						// no op
					}

					if (widget) {
						result.unshift({
							element,
							widgetType: key,
							widgetInstance: widget,
							widgetOptions: widget.option(),
						});
					}
				}
			}

			element = element.parentElement;
		}

		return result;
	}
}